import { InspectionTemplateSection } from "@/shared/models/Inspection";
import { MenuOptionType } from "@dexteel/mesf-core";
import AddIcon from "@mui/icons-material/Add";

export const useTemplateOptionsFunctions = ({
	newRevisionFor,
	hasPendingRevision,
}: {
	newRevisionFor: (section: InspectionTemplateSection) => void;
	hasPendingRevision: (sectionId: number) => boolean;
}) => {
	const getMenuOptions = (data: InspectionTemplateSection) => {
		const options: MenuOptionType[] = [];

		if (data && !hasPendingRevision(data.SectionId)) {
			options.push({
				name: data.Rev === null ? "Write First Revision" : "New Revision",
				key: "new_revision",
				onClick: () => newRevisionFor(data),
				icon: <AddIcon />,
			});
		}

		return options;
	};

	return { getMenuOptions };
};
